import { render, staticRenderFns } from "./DetailInvoiceCancelKirimBalik.vue?vue&type=template&id=b07f0b58&"
import script from "./DetailInvoiceCancelKirimBalik.vue?vue&type=script&lang=js&"
export * from "./DetailInvoiceCancelKirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports